import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';

import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import CTBChart from './CTBChart';
import CTBreakdown from './CTBreakdown';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';

import '../CTB.scss';

class WallboardCTBChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Cycle Time Breakdown Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="ctb" showBreakdown />
            <DatePicker />
          </div>
        </div>
        <div>
          <div className="dashboard_details">
            {this.props.breakdown && this.props.data.cycleTimes && !!this.props.data.cycleTimes.length && (
              <CTBreakdown id="ctbreakdown" data={this.props.data.cycleTimes} />
            )}
            <DetailsAccordion
              dateLabel={this.props.timeUnit === 'cards' ? 'Name' : 'Date'}
              valueLabel="Cycle time"
              value2Label="Throughput"
              id="details-accordion"
              data={this.state.selectedPoint}
            />
          </div>
          <div className="diagram_details">
            <CTBChart id="CTB" data={this.props.data.breakdown} onPointClick={this.handlePointClick} />
            <NoData
              show={this.props.data.breakdown && !this.props.data.breakdown.length}
              loading={this.props.isLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    breakdown: state.filters.ctb.breakdown,
    timeUnit: state.filters.ctb.timeUnit,
    data: state.ctb.data,
    isLoading: state.ctb.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTBChart);
